const semanticClassNames = {
  root: 'selection-tags',
  selectionsTagsOption: 'selection-tags__option',
} as const;

export default semanticClassNames;
